
<template>
  <div style="width:100%;height:100%;">
      <!--   <div>
        <input type="file" id="fileLoader" @change="onChange" :accept="acceptType" :multiple="multiple" style="display: none;" />
       <el-button @click="fileLoader.click()" size="small" icon="el-icon-plus" style="border: 1px dashed #d9d9d9">{{ label }}</el-button>
       <el-input readonly style="height: 40px; width: 220px; margin-left: 10px;" v-model="result.fileName" v-if="showExtName"></el-input>
      </div> -->
      <div style=" display: flex;flex-direction: row;">
          <span style="line-height: 32px;">选择坐标系</span>
         <div style="display: inline-block;margin: 0px 10px 10px 5px;" >
           <el-select size="small" v-model="type" @change="changeHandler">
                 <el-option
                    v-for="option in options"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"></el-option>
                <el-option label="大地2000坐标系" value="114"></el-option>
           </el-select>
        </div>
        <div style="margin-bottom: 10px;display: inline-block;">
           <pf-file-upload
                    v-model="dwgUploadList"
                    :actionUrl="dwgdwgUploadUrl"
                    :show-file-list="false"
                    :data="params"
                    @handleSuccess="uploadSuccess"
                    @submitUpload="submitUploadHandler"
                    :listType="'dwg'"
                    :isLimit="false"
                    accept=".dwg">
            </pf-file-upload>
        </div>
        <span style="font-size: 15px;color: red;line-height: 40px;margin-left: 5px;">注：目前仅支持导入dwg文件</span>
      </div>

       <div style="width:100%;display: flex;height: calc(100% - 42px);border: 1px solid #dedede;" id="id1">
         <div style="width:70%;height:100%;border-right: 1px solid #dedede;" class="mainMap" :id="zzMapId">
         </div>
         <div style="height:100%;width: 30%;">
             <div style="font-size: 16px;color: #333333;border-bottom: 1px solid #dddddd;height: 46px;line-height: 45px;padding: 0px 10px;">
                  <el-checkbox  v-model="allchecked" @change="allcheckBoxHandler()"></el-checkbox>地块列表({{count}}/{{selectCount}})
             </div>
             <div style="height: calc(100% - 48px);  padding-left: 10px;font-size: 23px;">
                 <el-scrollbar style="height: 100%;">
                      <ul>
                         <li v-for="(item, index) in list" :key="'list'+index"><!-- //`地块${index+1}` -->
                             <span><i  @click="dingwei(item)" title="定位" style="font-size: 25px;color: red;position: absolute;right: 10px;cursor: pointer;"
                              class="iconfont icon-dingweiqipao-"></i></span>
                             <el-checkbox :checked="item.checked" :key="index" :label="item.properties.name"  @change="checkBoxHandler(item)"></el-checkbox>

                         </li>
                     </ul>
                 </el-scrollbar>
             </div>
         </div>
      </div>
   </div>

</template>
<script>
import * as shapefile from 'shapefile'
import {Loading} from 'element-ui'
export default {
  name: 'mainMap',

  props: {
    // 可以创建多个地图对象
    mapid: {
      type: String
    },
    isloadData: {
      type: Boolean,
      default: true
    },
    istoolbar: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: '选择文件'
    },
    showExtName: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      type: '113.1333333333333',
      checkList: [],
      result: {
        fileName: '',
        feature: ''
      },
      acceptType: {
        type: String,
        default: '.dwg'
      },
      multiple: {
        type: Boolean,
        default: false
      },
      params: {centralMeridian: '113.1333333333333', resultType: 0, flag: true}, // 株洲独立坐标系
      dwgUploadList: [],
      dwgdwgUploadUrl: '/openApi/ConvertController/fileToGeoJson',
      isVisible: true,
      zzMapId: this.mapid || 'mapDiv_' + Math.ceil(Math.random() * 10000),
      mapoptins: this.mapOptins,
      mainMap: null,
      mapNavbar: null,
      list: [],
      selectFeatures: [],
      loading: null,
      allchecked: false,
      count: 0,
      selectCount: 0,
      map_Center: [27.842398471, 113.154482025],
      options: []
    }
  },
  created() {
    for (let i = 0; i < city.length; i++) {
      if (city[i].check === true) {
        this.map_Center = city[i].mapCenter
        const data = []
        data.label = city[i].cityname + '独立坐标系'
        data.value = city[i].zbx
        this.type = city[i].zbx
        this.options.push(data)
        this.params = {centralMeridian: city[i].zbx, resultType: 0, flag: true}
      }
    }
    this.$nextTick(() => {
      if (this.mapoptins === undefined) {
        this.mapoptins = {
          mapcrs: null,
          center: this.map_Center,
          zoomLevel: 12,
          zoomControl: true,
          visibleContextmenu: true

        }
      }
      if (this.zzMapId === undefined) this.zzMapId = 'mapDiv_' + Math.ceil(Math.random() * 10000)
      // 创建地图容器对象
      this.createMap(this.zzMapId, this.mapoptins)
      // 地图容器创建完成，触发initMapCompleteEvent事件
      // this.$event.$emit('ready', this.mainMap)

      const imgm = L.tiandituTileLayer({ layerType: 'img', key: '1d109683f4d84198e37a38c442d68311' })
      const imga = L.tiandituTileLayer({ layerType: 'cia', key: '1d109683f4d84198e37a38c442d68311' })
      this.mainMap.addLayer(imgm)
      this.mainMap.addLayer(imga)
    })
  },
  computed: {
    fileLoader() {
      return document.getElementById('fileLoader')
    }
  },
  mounted() {
    //
  },
  methods: {
    changeHandler(val) {
      this.params.centralMeridian = val
    },
    dingwei(feature) {
      const grouplayers = this.mainMap.importLayerGroup.getLayers()
      const layers = grouplayers[0]._layers
      for (const key in layers) {
        if (Object.hasOwnProperty.call(layers, key)) {
          const element = layers[key]
          if (element.feature.index === feature.index) {
            this.mainMap.fitBounds(element._bounds, { maxZoom: 15 })
            break
          }
        }
      }
    },
    allcheckBoxHandler() {
      const grouplayers = this.mainMap.importLayerGroup.getLayers()
      if (!this.allchecked) {
        this.selectCount = this.count
      }
      if (grouplayers && grouplayers.length > 0) {
        const layers = grouplayers[0]._layers
        if (layers) {
          const newlist = []
          for (const key in layers) {
            if (Object.hasOwnProperty.call(layers, key)) {
              const element = layers[key]
              element.feature.checked = this.allchecked
              for (let i = 0; i < this.list.length; i++) {
                const ele = this.list[i]
                if (ele.index === element.feature.index) {
                  ele.checked = this.allchecked
                  newlist.push(ele)
                  break
                }
              }
              if (element.feature.checked) {
                element.setStyle({opacity: 1})
                this.selectCount++
              } else {
                element.setStyle({opacity: 0})
                this.selectCount--
              }
            }
          }
          this.list = []
          const _this = this
          setTimeout(() => {
            _this.list = newlist
          }, 100)
        }
      }
    },
    submitUploadHandler() {
      this.loading = Loading.service({
        lock: true,
        background: 'rgba(255,255,255,0.5)'
      })
    },
    handleListChange(val) {

    },
    checkBoxHandler(feature) {
      const grouplayers = this.mainMap.importLayerGroup.getLayers()
      const layers = grouplayers[0]._layers
      for (const key in layers) {
        if (Object.hasOwnProperty.call(layers, key)) {
          const element = layers[key]
          if (element.feature.index === feature.index) {
            element.feature.checked = !element.feature.checked
            if (element.feature.checked) {
              element.setStyle({opacity: 1})
              this.selectCount++
            } else {
              element.setStyle({opacity: 0})
              this.selectCount--
            }
          }
        }
      }
      if (this.selectCount === this.count) {
        this.allchecked = true
      } else {
        this.allchecked = false
      }
    },
    uploadSuccess(data) {
      this.loading.close()
      this.mainMap.importLayerGroup.clearLayers()
      if (data.features && data.features.length > 0) {
        for (let i = 0; i < data.features.length; i++) {
          const feature = data.features[i]
          if (feature.properties.XMMC) {
            feature.properties.name = feature.properties.XMMC
          } else {
            feature.properties.name = '地块' + i + 1
          }
          feature.index = i
          feature.checked = true
        }
        const zzLayer = L.geoJSON(data.features)
        this.mainMap.importLayerGroup.addLayer(zzLayer)
        this.list = data.features
        this.selectFeatures = this.list

        this.allchecked = true
        this.count = data.features.length
        this.selectCount = data.features.length
        try {
          const bounds = this.mainMap.importLayerGroup.getBounds()
          this.mainMap.fitBounds(bounds)
        } catch (error) {

        }
      } else {
        this.$utils.info('解析不到项目范围线，请检查dwg文件')
      }
    },
    readShapeFile(shp, dbf, cb) {
      shapefile.read(shp, dbf, { encoding: 'gb2312' }).then(geojson => {
        // const features = geojson.features
        /* for (let f = 0; f < features.length; f++) {
          const coordinates = features[f].geometry.coordinates
          for (let i = 0; i < coordinates.length; i++) {
            const coordinate = coordinates[i]
            for (let j = 0; j < coordinate.length; j++) {
              coordinate[j].reverse() // x 和 y 对调一下
            }
          }
        } */
        cb && cb(geojson)
      })
    },
    // 格式化文件路径消除转义符
    formatFilePath(filePath) {
      let newPath = ''
      const strArr = filePath.split('\\')
      for (let i = 0; i < strArr.length; i++) {
        // eslint-disable-next-line no-useless-concat
        newPath += strArr[i] + '\\' + '\\'
      }
      newPath = newPath.substring(0, newPath.length - 2)
      return newPath
    },
    readfiles(shp, dbf, prj) {
      const reader1 = new FileReader()
      const reader2 = new FileReader()
      reader1.onload = ev1 => {
        reader2.onload = ev2 => {
          this.readShapeFile(ev1.target.result, ev2.target.result, geojson => {
            this.uploadSuccess(geojson)
            this.$emit('resolve-end', geojson)
          })
        }
        reader2.readAsArrayBuffer(dbf)
      }
      reader1.readAsArrayBuffer(shp)
    },
    onChange(e) {
      this.loading = Loading.service({
        lock: true,
        background: 'rgba(255,255,255,0.5)'
      })
      const files = this.fileLoader.files
      if (files.length === 0) return
      if (this.multiple) {
        let shp, dbf
        if (files.length === 1) {
          const filePath = files[0].name
          this.result.fileName = filePath
          const suffix = filePath.substring(filePath.lastIndexOf('.') + 1, filePath.length)
          if (suffix === 'shp') {
            this.$message.error('请同时选择后缀名为.dbf的同名文件')
            return
          } else if (suffix === 'dbf') {
            this.$message.error('请同时选择后缀名为.shp的同名文件')
            return
          } else {
            this.readFile(suffix)
          }
        }
        for (let i = 0, len = files.length; i < len; i++) {
          const file = files[i]
          const filePath = file.name
          const suffix = filePath.substring(filePath.lastIndexOf('.') + 1, filePath.length)
          if (suffix === 'shp') {
            shp = file
            this.result.fileName = shp.name
          } else if (suffix === 'dbf') {
            dbf = file
          } else {
            this.$message.error('禁止操作')
            return
          }
        }
        this.readfiles(shp, dbf)
      } else {
        const filePath = files[0].name
        this.result.fileName = filePath
        const suffix = filePath.substring(filePath.lastIndexOf('.') + 1, filePath.length)
        this.readFile(suffix)
      }
    },
    createMap(mapDivid, mapOptins) {
      const c = Math.PI * 2 * 6378137
      const halfC = c / 2
      // eslint-disable-next-line camelcase
      const tdt_Mercator_resolutions = []
      for (let i = 1; i < 19; i++) {
        tdt_Mercator_resolutions.push(c / 256 / Math.pow(2, i))
      }
      // eslint-disable-next-line camelcase
      const TianDiTu_MercatorCRS = new L.Proj.CRS('EPSG:3857', '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs',
        {
          origin: [-halfC, halfC],
          resolutions: tdt_Mercator_resolutions,
          bounds: L.bounds([-halfC, -halfC], [halfC, halfC]),
          wrapLng: [-180, 180]
        })
      this.mainMap = L.map(mapDivid, {
        crs: TianDiTu_MercatorCRS,
        center: mapOptins.center,
        attributionControl: false,
        doubleClickZoom: false,
        closePopupOnClick: false,
        zoom: mapOptins.zoomLevel,
        maxZoom: 17,
        minZoom: 7,
        zoomControl: mapOptins.zoomControl,
        contextmenu: mapOptins.visibleContextmenu, // 地图右键
        contextmenuWidth: 140,
        contextmenuItems: mapOptins.contextmenuItemsAry
      })
      const importLayerGroup = L.featureGroup().addTo(this.mainMap)
      this.mainMap.importLayerGroup = importLayerGroup

      const resultHighlightLayerGroup = L.featureGroup().addTo(this.mainMap)
      this.mainMap.resultHighlightLayerGroup = resultHighlightLayerGroup

      const _this = this
      this.mainMap.importLayerGroup.on('click', e => {
        const layer = e.sourceTarget
        const newlist = []
        for (let i = 0; i < _this.list.length; i++) {
          const element = _this.list[i]
          if (element.index === layer.feature.index) {
            element.checked = !layer.feature.checked
            if (element.checked) {
              layer.setStyle({opacity: 1})
              _this.selectCount++
            } else {
              layer.setStyle({opacity: 0})
              _this.selectCount--
            }
          }
          newlist.push(element)
        }
        _this.list = []
        setTimeout(() => {
          _this.list = newlist
        }, 100)
        if (_this.selectCount === _this.count) {
          _this.allchecked = true
        } else {
          _this.allchecked = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mainMap {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: default;
  position: relative;
}
.el-scrollbar{
    ::v-deep{
        .el-scrollbar__wrap{
            overflow-x: hidden;
        }
    }
}
</style>
